// 登录
export const autoCode = '/service/api/Login/GetAuthCode?time=' + Math.random()
export const checkLogin = '/service/api/Login/CheckLogin?time=' + Math.random()
export const editPsd = '/service/api/User/ModifyUserPassword'
export const outLogin = 'service/api/Login/Logout'
// export const editPsd = '/service/api/User/ModifyUserPassword'
// export const outLogin = '/service/api/service/api/Login/Logout'
// export const editPsd = '/service/api/User/ModifyUserPassword'
// export const outLogin = '/service/api/Login/Logout'

//首页
export const getControlPanelData = '/service/api/Home/GetManageControlPanelData'
export const getStatistics = '/service/api/Home/GetStatistics'
export const getExamPlanSettingInfo = '/service/api/Home/GetExamPlanSettingInfo'
export const getShowClient = '/service/api/ClientData/GetClientDataJson'
export const getCurrUserInfo = '/service/api/User/GetCurrentUserInfo'
export const UpdateCurrUserInfo = '/service/api/User/UpdateCurrentUserInfo'
export const checkSingleLogin = '/service/api/ClientData/CheckSingleLogin'

//系统管理
export const getConfigList = '/service/api/SiteConfig/GetConfigList'
export const setConfigValue1 = '/service/api/SiteConfig/SetConfigValue1'
export const setConfigValue = '/service/api/SiteConfig/SetConfigValue2'
export const getRoleList = '/service/api/Role/GetList'
export const submitForm = '/service/api/Role/SubmitForm'
export const delRoleItem = '/service/api/Role/DelRoleItem?time=' + Math.random()
export const getRolePrivileges = '/service/api/Role/GetRolePrivileges'
export const setRolePrivilege = '/service/api/Role/SetRolePrivilege'
export const getRoleSelectJsonByRoleType = '/service/api/Role/GetRoleSelectJsonByRoleType'
export const getUserGridJson = '/service/api/User/GetGridJson'
export const setUserState = '/service/api/User/EnabledAccount'
export const delUser = '/service/api/User/DeleteForm'
export const getAllExamTypePrivileges = '/service/api/UserRolePrivilege/GetAllExamTypePrivileges'
export const submitUserForm = '/service/api/User/SubmitForm'
export const getUserRoleIds = '/service/api/Role/GetUserRoleIds'
export const getFormJson = '/service/api/User/GetFormJson'
export const getUserRolePrivilegeList = '/service/api/UserRolePrivilege/GetGridJson'
export const getRoleSelectJson = '/service/api/Role/GetRoleSelectJson'
export const setUserRole = '/service/api/Role/SetUserRole'
export const getUserPrivileges = '/service/api/UserRolePrivilege/GetUserPrivileges'
export const setUserExamTypePrivileges = '/service/api/UserRolePrivilege/SetUserExamTypePrivileges'
export const setUserPrivilege = '/service/api/Privilege/SetUserPrivilege'
export const getConfigById = '/service/api/SiteConfig/GetConfigById'
export const editSwitch = '/service/api/TeacherMarkSet/EditPaperInfo'
export const getNumberNameSet = '/service/api/Student/GetNumberNameSet'
export const uploadPackage = '/service/api/PaperPackage/UploadFiles'




//教师管理
export const teacherList = '/service/api/Teacher/GetTeacherCourseGridJson'
export const roleType = '/service/api/Role/GetRoleSelectJsonByRoleType'
export const addTeacher = '/service/api/Teacher/SubmitForm'
export const deleteTeacher = '/service/api/Teacher/DeleteForm'
export const exportTeacherCourse = '/service/api/Teacher/ExportTeacherCourseJson'
export const teaSwitchState = '/service/api/Teacher/EnabledAccount'
export const TeacherCourseImport = '/service/api/Teacher/TeacherCourseImport'
export const getCourse = '/service/api/Course/GetCourseJson'
export const readList = '/service/api/TeacherMarkSet/GetGridJson'
export const testPlan = '/service/api/ExamPlan/GetAllExamJson'
export const GetMarkRule = '/service/api/TeacherMarkSet/GetMarkSetRule'
export const saveMarkRule = '/service/api/TeacherMarkSet/UpdateMarkSetRule'
export const allocation = '/service/api/TeacherMarkSet/BatchAssignTeacherMarkSet'
export const batchTeaDelete = '/service/api/TeacherMarkSet/BatchDelete'
export const detailList= '/service/api/TeacherMarkSet/GetTeacherMarkSetDetail'
export const teaInfo= '/service/api/TeacherMarkSet/GetUserMarkSetInfo'
export const paperBindInfo= '/service/api/TeacherMarkSet/GetPaperBindInfo'
export const exportMarkSet= '/service/api/TeacherMarkSet/ExportTeacherMarkSet'
export const deleteMarkSet= '/service/api/TeacherMarkSet/DeleteMarkSet'
export const addSetDetail= '/service/api/TeacherMarkSet/SubmitMarkSetDetail'
export const editSetDetail= '/service/api/TeacherMarkSet/EditMarkSetDetail'
export const notSetSequence= '/service/api/TeacherMarkSet/GetNotSetSubjectiveSequence'
export const examCourseCode= '/service/api/ExamPlan/GetExamCourseId'
export const teaResultList= '/service/api/TeacherMarkSet/GetTeacherMarkSetResultList'
export const ImportTeacherMark= '/service/api/TeacherMarkSet/ImportTeacherMark'
export const getTeaCourseJson= '/service/api/Teacher/GetFormJson'
export const getImportArea= '/service/api/TeacherMarkSet/GetMarkSetResultImportArea'
export const exportTeaTemplate= '/service/api/TeacherMarkSet/ExportTeacherMarkSetTemplate'
export const ImportTeaXls= '/service/api/TeacherMarkSet/ImportTeacherMarkSetXls'

//查询统计
export const useExamPlan= '/service/api/ExamPlan/GetEnableExamJson'
export const getScoreList= '/service/api/Student/GetGridJson'
export const exportStudentScore= '/service/api/Student/ExcelOutStudentScore'
export const exportPassingRate= '/service/api/Student/ExcelOutPassingRate'
export const exportFeedBack= '/service/api/Student/ExcelOutFeedBack'
export const exportScoreCallBack= '/service/api/Student/StudentScoreCallBack'
export const getLogOptType= '/service/api/MarkLog/GetLogOptType'
export const getMarkLog= '/service/api/MarkLog/GetMarkLogGrid'
export const getTeacherJson= '/service/api/Teacher/GetTeacherJson'
export const getReviewOperateGrid= '/service/api/OnlineReview/GetReviewOperateGrid'
export const getSignInfo= '/service/api/SignInfo/GetGridJson'
export const getSignImg= '/service/api/SignInfo/GetSignInfoImg'
export const getPackageLogList= '/service/api/PaperPackage/GetPlacePackageLogList'
export const reviewList= '/service/api/JudgeStatistics/GetGridJsonForReview'
export const qualityList= '/service/api/JudgeStatistics/GetQualityJudgeStatistics'
export const totalQualityData= '/service/api/JudgeStatistics/GetTotalJudgeForQuality'
export const reviewResult= '/service/api/JudgeStatistics/GetTotalJudgeForReview'
export const getGridJsonForTeacher= '/service/api/JudgeStatistics/GetGridJsonForTeacher'
export const teacherJudegExcelOut= '/service/api/JudgeStatistics/TeacherJudegExcelOut'
export const getExamGridJson= '/service/api/JudgeStatistics/GetGridJson'
export const paperJudegExcelOut= '/service/api/JudgeStatistics/PaperJudegExcelOut'
export const getTeacherReviewStudentGrid= '/service/api/JudgeStatistics/GetTeacherReviewStudentGrid'
export const exportQualityJudgeStatistics= '/service/api/JudgeStatistics/ExportQualityJudgeStatistics'
export const getTotalJudgeForReview= '/service/api/JudgeStatistics/GetTotalJudgeForReview'
export const exportReviewWork= '/service/api/JudgeStatistics/ReviewJudegExcelOut'
export const getQualityStatistics= '/service/api/JudgeStatistics/GetQualityStatistics'
export const teaQualityResult= '/service/api/JudgeStatistics/GetTotalJudgeForQuality'
export const exportQualityStatistics= '/service/api/JudgeStatistics/ExportQualityStatistics'
export const getViolateType= '/service/api/SiteConfig/GetViolateType'
export const getExamAnalysis= '/service/api/Paper/GetExamAnalysis'
export const getExamAnalysisField= '/service/api/SiteConfig/GetExamAnalysisField'
export const setExamAnalysisField= '/service/api/SiteConfig/SetExamAnalysisField'
export const getExamCourseList= '/service/api/Course/GetExamCourseList'
export const getPaperTypeList= '/service/api/Paper/GetPaperTypeList'
export const getPaperAnalysis= '/service/api/Paper/GetPaperAnalysis'
export const getExamAnalysisTotal= '/service/api/Paper/GetExamAnalysisTotal'
export const getPaperAnalysisChartData= '/service/api/Paper/GetPaperAnalysisChartData'
export const exportExamAnalysis= '/service/api/Paper/ExportExamAnalysis'
export const exportPaperAnalysis= '/service/api/Paper/ExportPaperAnalysis'





// 客户端
export const getExamOrder= '/service/api/ExamPlan/GetExamOrder'
export const getExamClass= '/service/api/ExamPlan/GetExamClass'
export const getHeader= '/service/api/Student/GetDisplayField'
export const getScanJson= '/service/api/Scan/GetScanStudentGridJson'
export const exportScan= '/service/api/Scan/ExportScanStudent'


//考生管理
export const getHighManageList = '/service/api/Student/GetHighManageList'
export const getEnableExamJson = '/service/api/ExamPlan/GetEnableExamJson'
export const getExamStation = '/service/api/ExamPlan/GetExamStation'
export const getExamCourseCode = '/service/api/ExamPlan/GetExamCourseCode'
export const getCheckState = '/service/api/SiteConfig/GetCheckState'
export const getStudentField = '/service/api/Student/GetStudentField'
export const highManageCheckState = '/service/api/Student/HighManageCheckState'
export const saveHighManagePaperState = '/service/api/Student/SaveHighManagePaperState'
export const getExamBatch = '/service/api/ExamPlan/GetExamBatch'
export const getExamLevel = '/service/api/ExamPlan/GetExamLevel'
export const getExamSubject = '/service/api/ExamPlan/GetExamSubject'
export const getStudentInfoGridJson = '/service/api/Student/GetStudentInfoGridJson'
export const deleteForm = '/service/api/Student/DeleteForm'
export const batchDelete = '/service/api/Student/BatchDelete'
export const deleteQueryStudents = '/service/api/Student/DeleteQueryStudents'
export const excelOut = '/service/api/Student/ExcelOut'
export const downloadFile = '/service/api/Download/DownloadFile'
export const studentInfoImport = '/service/api/Student/StudentInfoImport'
export const getStudentPaperJson = '/service/api/Student/GetStudentPaperJson'
export const releaseBindStudent = '/service/api/Student/ReleaseBindStudent'
export const saveHighManagePaperObjectiveAnswer = '/service/api/Student/SaveHighManagePaperObjectiveAnswer'
export const getSignInfoImg = '/service/api/Student/GetSignInfoImg'
export const getStudentInfoImportTemplate = '/service/api/Student/GetStudentInfoImportTemplate'
export const getStudentImportInfo = '/service/api/Student/GetStudentImportInfo'
export const getExamPlace = '/service/api/ExamPlan/GetExamPlace'

//基础数据
export const getGridJson = '/service/api/ExamPlan/GetGridJson'
export const getExamTypeList = '/service/api/ExamPlan/GetExamTypeList'
export const submitFormExamPlan = '/service/api/ExamPlan/SubmitForm'
export const getExamPlanFormJson = '/service/api/ExamPlan/GetFormJson'
export const deleteExamPlanForm = '/service/api/ExamPlan/DeleteForm'
export const enabledExam = '/service/api/ExamPlan/EnabledExam'
export const getTeacherCourseGridJson = '/service/api/Course/GetGridJson'
export const SubmitFormCourse = '/service/api/Course/SubmitForm'
export const deleteCourseForm = '/service/api/Course/DeleteForm'


//试卷管理
export const getPaperGridJson = '/service/api/PaperAnswer/GetPaperGridJson'
export const getPaperAnswerGridJson = '/service/api/PaperAnswer/GetPaperAnswerGridJson'
export const getPaperAnswerFormJson = '/service/api/PaperAnswer/GetPaperAnswerFormJson'
export const paperAnswerSubmitForm = '/service/api/PaperAnswer/PaperAnswerSubmitForm'
export const deleteAnswerForm = '/service/api/PaperAnswer/DeleteForm'
export const getPaperJson = '/service/api/PaperAnswer/GetPaperJson'
export const getExaminationGridJson = '/service/api/PaperPackage/GetGridJson'
export const uploadFiles = '/service/api/PaperAnswer/UploadFiles'
export const getSyncOtsPaperList = '/service/api/PaperAnswer/GetSyncOtsPaperList'
export const getOTSAutoRelationRules = '/service/api/PaperAnswer/GetOTSAutoRelationRules'
export const setOTSAutoRelationRules = '/service/api/PaperAnswer/SetOTSAutoRelationRules'
export const setAutoRelation = '/service/api/PaperAnswer/AutoRelation'
export const getOTSPaperList = '/service/api/PaperAnswer/GetOTSPaperList'
export const autoAnswerSync = '/service/api/PaperAnswer/AutoAnswerSync'
export const getOTSCourseJson = '/service/api/PaperAnswer/GetOTSCourseJson'
export const relationOnePaper = '/service/api/PaperAnswer/RelationOnePaper'
export const unRelationOnePaper = '/service/api/PaperAnswer/UnRelationOnePaper'
export const answerSyncOnePaper = '/service/api/PaperAnswer/AnswerSyncOnePaper'
export const getPaperTemplateGridJson = '/service/api/PaperTemplate/GetPaperTemplateGridJson'
export const getAllTemplate = '/service/api/PaperTemplate/GetAllTemplate'
export const setTempletToPaper = '/service/api/PaperTemplate/SetTemplateToPaper'
export const setPaperPageCount = '/service/api/PaperTemplate/SetPaperPageCount'
export const importPageCount = '/service/api/PaperTemplate/ImportPageCount'
export const getPackageRule = '/service/api/PaperPackage/GetPackageRule'
export const setPackageRule = '/service/api/PaperPackage/SetPackageRule'
export const createPackageNumber = '/service/api/PaperPackage/CreatePackageNumber'
export const copyPackageNumber = '/service/api/PaperPackage/CopyPackageNumber'
export const deletePackageNumber = '/service/api/PaperPackage/DeletePackageNumber'
export const checkPackageInfo = '/service/api/PaperPackage/CheckPackageInfo'
export const uploadPaper = '/service/api/PaperAnswer/UploadPaper'
export const getPaperPackageInfo = '/service/api/PaperPackage/GetPaperPackageInfo'
export const deleteLocalPaper = '/service/api/PaperAnswer/DeleteLocalPaper'

//评阅管理
export const  getOnlineReviewExamPlan = '/service/api/OnlineReview/GetOnlineReviewExamPlan'
export const  getOnlineReviewData = '/service/api/OnlineReview/GetOnlineReviewData'
export const  getCurrentUserInfo = '/service/api/User/GetCurrentUserInfo'
export const  getConfigValue2ByKey = '/service/api/SiteConfig/GetConfigValue2ByKey'
export const  getStudentPaper = '/Service/Api/OnlineReview/GetStudentPaper'
export const  getQualityExamPlan = '/Service/Api/PaperQuality/GetQualityExamPlan'
export const  getQualityPaperData = '/Service/Api/PaperQuality/GetQualityPaperData'
export const  getExamMarkSetPaper = '/Service/Api/ExamPlan/GetExamMarkSetPaper'
export const  getPaperQualityDetailData = '/Service/Api/PaperQuality/GetPaperQualityDetailData'
export const  saveBulkQuality = '/Service/Api/PaperQuality/SaveBulkQuality'
export const  cancelPaperQuality = '/Service/Api/PaperQuality/CancelPaperQuality'
export const  getFeedBack = '/Service/Api/OnlineReview/GetFeedBack'
export const  saveFeedBack = '/Service/Api/OnlineReview/SaveFeedBack'
export const  deleteFeedBack = '/Service/Api/OnlineReview/DeleteFeedBack'
export const  getOnlineReviewStatisticsGrid = '/Service/Api/OnlineReview/GetOnlineReviewStatisticsGrid'
export const  getUserMarkSetExamPlan = '/Service/Api/TeacherMarkSet/GetUserMarkSetExamPlan'
export const  getUserExamCourse = '/Service/Api/TeacherMarkSet/GetUserExamCourse '
export const  getUserExamBatch = '/Service/Api/TeacherMarkSet/GetUserExamBatch'
export const  getUserExamLevel = '/Service/Api/TeacherMarkSet/GetUserExamLevel'
export const  getUserExamSubject = '/Service/Api/TeacherMarkSet/GetUserExamSubject'
export const  getUserExamStation = '/Service/Api/TeacherMarkSet/GetUserExamStation'
export const  saveScore = '/Service/Api/OnlineReview/SaveScore'
export const  saveReviewMark = '/Service/Api/OnlineReview/SaveReviewMark'
export const  releaseJudgeState = '/Service/Api/OnlineReview/ReleaseJudgeState'
export const  tempSaveScore = '/Service/Api/OnlineReview/TempSaveScore'
export const  getStudentPaperInfo = '/Service/Api/PaperQuality/GetStudentPaperInfo'
export const  saveQuality = '/Service/Api/PaperQuality/SaveQuality'
export const  saveOperateLog = '/Service/Api/OnlineReview/SaveOperateLog'
export const  getConfigValue1ByKey = '/Service/Api/SiteConfig/GetConfigValue1ByKey'


//生成扫描测试数据
export const  initTestScanData = '/Service/Api/Test/InitScanData'

//表格
export const getUserGridSet = '/Service/api/SiteConfig/GetUserGridFiled'
export const setUserGrid = '/Service/api/SiteConfig/SetUserGridFiled'
export const setFrozenColunm = '/Service/api/SiteConfig/SetFrozenColunm'
